import RadioButton from 'components/formComponents/Base/RadioButton';
import { MoreApplicationsChoice } from '../../../../../types/PartyApplication/partyApplication';
import { StartSectionTexts } from '../../../../../types/PartyApplication/PartyApplicationTexts';
type Props = {
  texts?: StartSectionTexts;
};

const MoreApplicationsSelect: React.FC<Props> = ({ texts }) => {
  return (
    <>
      <RadioButton
        name="moreApplications"
        header={texts?.moreApplicationsSubHeadline ?? ''}
        options={[
          {
            id: String('moreApplications-' + MoreApplicationsChoice.Yes),
            value: MoreApplicationsChoice.Yes,
            displayValue: texts?.moreApplicationsYesRadioBtn?.label ?? 'Ja',
            sortOrder: texts?.moreApplicationsYesRadioBtn?.radioSortOrder ?? 1,
          },
          {
            id: String('moreApplications-' + MoreApplicationsChoice.No),
            value: MoreApplicationsChoice.No,
            displayValue: texts?.moreApplicationsNoRadioBtn?.label ?? 'Nej',
            sortOrder: texts?.moreApplicationsNoRadioBtn?.radioSortOrder ?? 2,
          },
        ]}
      />{' '}
    </>
  );
};

export default MoreApplicationsSelect;
